import * as BootstrapIcons from "react-bootstrap-icons";
import * as SimpleIcons from "react-icons/si";
import { cn } from "@heroui/react";

import { Option } from "@/types/dataSchema";

export const bootstrapIcons = BootstrapIcons;

export const getIconFromBoostrapIconKey = (
  bootstrapIconName: string,
  classNames: string[],
  style?: React.CSSProperties,
) => {
  const IconComponent = (BootstrapIcons as any)[bootstrapIconName];

  if (!IconComponent) {
    // eslint-disable-next-line no-console
    console.warn(
      `Icon ${bootstrapIconName} not found in react-bootstrap-icons`,
    );

    return null;
  }

  return <IconComponent className={cn(classNames)} style={style} />;
};

export const getIconComponent = (option: Option): React.ElementType | null => {
  let IconComponent: React.ElementType | null = null;

  if (option.simpleIconName) {
    const key = "Si" + option.simpleIconName;

    if ((SimpleIcons as any)[key]) {
      IconComponent = (SimpleIcons as any)[key];
    } else {
      // console.warn(`Icon ${key} not found in react-icons/si`);
      if (
        option.bootstrapIconName &&
        (BootstrapIcons as any)[option.bootstrapIconName]
      ) {
        IconComponent = (BootstrapIcons as any)[option.bootstrapIconName];
      }
    }
  } else if (
    option.bootstrapIconName &&
    (BootstrapIcons as any)[option.bootstrapIconName]
  ) {
    IconComponent = (BootstrapIcons as any)[option.bootstrapIconName];
  }

  return IconComponent;
};

export enum Sizes {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export interface LayoutConfig {
  size: Sizes;
  buttonSize: string;
  gridCols: string;
}

export const getLayoutConfig = (optionsLength: number): LayoutConfig => {
  let size: Sizes;
  let buttonSize = "p-4 text-base";
  let gridCols = "grid-cols-1";

  if (optionsLength === 2) {
    buttonSize = "p-4 text-base";
    gridCols = "2xl:grid-cols-2";
    size = Sizes.LARGE;
  } else if (optionsLength === 3) {
    buttonSize = "p-4 text-base";
    gridCols = "2xl:grid-cols-3";
    size = Sizes.LARGE;
  } else if (optionsLength > 9) {
    buttonSize = "p-2 text-xs";
    gridCols = "2xl:grid-cols-4";
    size = Sizes.SMALL;
  } else if (optionsLength === 4) {
    buttonSize = "p-3 text-sm";
    gridCols = "2xl:grid-cols-4";
    size = Sizes.LARGE;
  } else {
    buttonSize = "p-4 text-base";
    gridCols = "2xl:grid-cols-3";
    size = Sizes.MEDIUM;
  }

  return { size, buttonSize, gridCols };
};

export const filterOptionsByConditions = (
  options: Option[],
  currentAnswersFromContext: Record<string, any>,
): Option[] => {
  return options.filter((option) => {
    // Filter options based on conditions
    if (!option.conditions || option.conditions.length === 0) {
      return true; // No conditions, always include
    }

    return option.conditions.every((condition) => {
      if (condition.operator === "equals") {
        return Object.entries(currentAnswersFromContext).some(
          ([questionId, answerId]) =>
            answerId === condition.value && questionId === condition.questionId,
        );
      } else if (condition.operator === "not_equals") {
        return !Object.entries(currentAnswersFromContext).some(
          ([questionId, answerId]) =>
            answerId === condition.value && questionId === condition.questionId,
        );
      } else if (condition.operator === "includes") {
        return Object.entries(currentAnswersFromContext).some(
          ([questionId, answerIds]) =>
            answerIds.includes(condition.value) &&
            questionId === condition.questionId,
        );
      } else if (condition.operator === "not_includes") {
        return !Object.entries(currentAnswersFromContext).some(
          ([questionId, answerIds]) =>
            answerIds.includes(condition.value) &&
            questionId === condition.questionId,
        );
      } else {
        throw new Error(
          `Unsupported operator: ${condition.operator} in conditions`,
        );
      }
    });
  });
};
